module.exports = __webpack_public_path__ + "img/collag2.ba05fb0a.png";